import { ExtensionsCard } from "#web/components/blocking/ExtensionsCard";
import { BookDemoCard } from "#web/components/BookDemoCard";
import { ChangelogCard } from "#web/components/feedback/ChangelogCard";
import { FeedbackModal } from "#web/components/feedback/FeedbackModal";
import { SupportCard } from "#web/components/helpdesk/SupportCard";
import { DangerousLeaksCard } from "#web/components/leaks/DangerousLeaksCard";
import { LeaksCard } from "#web/components/leaks/LeaksCard";
import { OnboardingGuide } from "#web/components/onboarding/OnboardingGuide/OnboardingGuide";
import { ShopUserQuery } from "#web/components/shop/queries/shopUserQuery";
import { routeConfig } from "#web/configs/route";
import { i18nLike } from "#web/services/i18nLike";
import { Box, Layout, Page } from "@shopify/polaris";
import { PlanIcon, SettingsIcon } from "@shopify/polaris-icons";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { StackAppPromotion } from "#web/components/helpdesk/StackAppPromotion";

import * as s from "./Dashboard.css";

const en = {
  settings: "Settings",
  title: "Hey {{firstName}} 👋",
  unknownFirstName: "there",
  upgrade: "Upgrade",
};

export const Dashboard = () => {
  const t = i18nLike(en);
  const navigate = useNavigate();

  const { data: shopUser, isFetching: shopUserFetching } = useQuery(ShopUserQuery());
  const firstName = shopUserFetching ? "..." : (shopUser?.name?.split(" ")[0] ?? t("unknownFirstName"));

  return (
    <div className={s.DashboardPageWrapper}>
      <Page
        secondaryActions={[
          {
            accessibilityLabel: t("upgrade"),
            content: t("upgrade"),
            icon: PlanIcon,
            onAction: () => {
              navigate(routeConfig.billing["/"]);
            },
          },
          {
            accessibilityLabel: t("settings"),
            content: t("settings"),
            icon: SettingsIcon,
            onAction: () => {
              navigate(routeConfig.settings["/"]);
            },
          },
        ]}
        title={t("title", { firstName })}
      >
        <Box padding="100" />
        <Layout>
          <BookDemoCard />
          <Layout.Section variant="fullWidth">
            <OnboardingGuide />
          </Layout.Section>
          <Layout.Section variant="oneThird">
            <LeaksCard />
          </Layout.Section>
          <Layout.Section variant="oneThird">
            <DangerousLeaksCard />
          </Layout.Section>
          <Layout.Section variant="fullWidth">
            <ExtensionsCard />
          </Layout.Section>
          <Layout.Section variant="fullWidth">
            <StackAppPromotion />
          </Layout.Section>
          <Layout.Section variant="fullWidth">
            <SupportCard />
          </Layout.Section>
          <Layout.Section variant="fullWidth">
            <ChangelogCard />
          </Layout.Section>
        </Layout>
        <FeedbackModal />
      </Page>
    </div>
  );
};
